import { createAction } from 'redux-actions'

const defaultPrefix = 'CM/'
let prefix = defaultPrefix

export const resetState = createAction(`${prefix}RESET_STATE`)

// DATA
prefix = `${defaultPrefix}DATA/`
export const fetchAll = createAction(`${prefix}FETCH_ALL`)

export const fetchContactsStart = createAction(`${prefix}FETCH_CONTACTS_START`)
export const fetchContactsSuccess = createAction(`${prefix}FETCH_CONTACTS_SUCCESS`)
export const fetchContactsError = createAction(`${prefix}FETCH_CONTACTS_ERROR`)

export const smartSearchStart = createAction(`${prefix}SMART_SEARCH_START`)
export const clearSmartSearchFilterIds = createAction(`${prefix}CLEAR_SMART_SEARCH_FILTER_IDS`)

export const fetchSmartSearchContactIdsStart = createAction(`${prefix}FETCH_SMART_SEARCH_CONTACT_IDS_START`)
export const fetchSmartSearchContactIdsSuccess = createAction(`${prefix}FETCH_SMART_SEARCH_CONTACT_IDS_SUCCESS`)
export const fetchSmartSearchContactIdsError = createAction(`${prefix}FETCH_SMART_SEARCH_CONTACT_IDS_ERROR`)

export const fetchMoreContactsStart = createAction(`${prefix}FETCH_MORE_CONTACTS_START`)
export const fetchMoreContactsStop = createAction(`${prefix}FETCH_MORE_CONTACTS_STOP`)

export const fetchEmailEventsStart = createAction(`${prefix}FETCH_EMAIL_EVENTS_START`)
export const fetchEmailEventsSuccess = createAction(`${prefix}FETCH_EMAIL_EVENTS_SUCCESS`)
export const fetchEmailEventsError = createAction(`${prefix}FETCH_EMAIL_EVENTS_ERROR`)

export const fetchEarnedMediaStart = createAction(`${prefix}FETCH_EARNED_MEDIA_START`)
export const fetchEarnedMediaSuccess = createAction(`${prefix}FETCH_EARNED_MEDIA_SUCCESS`)
export const fetchEarnedMediaError = createAction(`${prefix}FETCH_EARNED_MEDIA_ERROR`)

export const updateContacts = createAction(`${prefix}UPDATE_CONTACTS`)
export const setTotalContacts = createAction(`${prefix}SET_TOTAL_CONTACTS`)
export const clearContacts = createAction(`${prefix}CLEAR_CONTACTS`)

export const fetchDistributionListsStart = createAction(`${prefix}FETCH_DISTRIBUTION_LISTS_START`)
export const fetchDistributionListsSuccess = createAction(`${prefix}FETCH_DISTRIBUTION_LISTS_SUCCESS`)
export const fetchDistributionListsError = createAction(`${prefix}FETCH_DISTRIBUTION_LISTS_ERROR`)

export const updateDistributionLists = createAction(`${prefix}UPDATE_DISTRIBUTION_LISTS`)
export const setTotalDistributionLists = createAction(`${prefix}SET_TOTAL_DISTRIBUTION_LISTS`)
export const fetchMoreDistributionListsStart = createAction(`${prefix}FETCH_MORE_DISTRIBUTION_LISTS_START`)
export const fetchMoreDistributionListsStop = createAction(`${prefix}FETCH_MORE_DISTRIBUTION_LISTS_STOP`)

export const fetchSmartSearchDistributionListIdsStart = createAction(`${prefix}FETCH_SMART_SEARCH_DISTRIBUTION_LIST_IDS_START`)
export const fetchSmartSearchDistributionListIdsSuccess = createAction(`${prefix}FETCH_SMART_SEARCH_DISTRIBUTION_LIST_IDS_SUCCESS`)
export const fetchSmartSearchDistributionListIdsError = createAction(`${prefix}FETCH_SMART_SEARCH_DISTRIBUTION_LIST_IDS_ERROR`)

export const createDistributionListStart = createAction(`${prefix}CREATE_DISTRIBUTION_LIST_START`)
export const createDistributionListSuccess = createAction(`${prefix}CREATE_DISTRIBUTION_LIST_SUCCESS`)
export const createDistributionListError = createAction(`${prefix}CREATE_DISTRIBUTION_LIST_ERROR`)

export const deleteDistributionListsStart = createAction(`${prefix}DELETE_DISTRIBUTION_LISTS_START`)
export const deleteDistributionListsSuccess = createAction(`${prefix}DELETE_DISTRIBUTION_LISTS_SUCCESS`)
export const deleteDistributionListsError = createAction(`${prefix}DELETE_DISTRIBUTION_LISTS_ERROR`)

export const updateDistributionListStart = createAction(`${prefix}UPDATE_DISTRIBUTION_LIST_START`)
export const updateDistributionListSuccess = createAction(`${prefix}UPDATE_DISTRIBUTION_LIST_SUCCESS`)
export const updateDistributionListError = createAction(`${prefix}UPDATE_DISTRIBUTION_LIST_ERROR`)

export const exportDistributionListStart = createAction(`${prefix}EXPORT_DISTRIBUTION_LIST_START`)
export const exportDistributionListSuccess = createAction(`${prefix}EXPORT_DISTRIBUTION_LIST_SUCCESS`)
export const exportDistributionListError = createAction(`${prefix}EXPORT_DISTRIBUTION_LIST_ERROR`)

export const mergeDistributionListsStart = createAction(`${prefix}MERGE_DISTRIBUTION_LISTS_START`)
export const mergeDistributionListsSuccess = createAction(`${prefix}MERGE_DISTRIBUTION_LISTS_SUCCESS`)
export const mergeDistributionListsError = createAction(`${prefix}MERGE_DISTRIBUTION_LISTS_ERROR`)

export const fetchContactStart = createAction(`${prefix}FETCH_CONTACT_START`)
export const fetchContactSuccess = createAction(`${prefix}FETCH_CONTACT_SUCCESS`)
export const fetchContactError = createAction(`${prefix}FETCH_CONTACT_ERROR`)

export const clearDetailPage = createAction(`${prefix}CLEAR_DETAIL_PAGE_CONTACT`)

export const createContactStart = createAction(`${prefix}CREATE_CONTACT_START`)
export const createContactSuccess = createAction(`${prefix}CREATE_CONTACT_SUCCESS`)
export const createContactError = createAction(`${prefix}CREATE_CONTACT_ERROR`)

export const updateContactStart = createAction(`${prefix}UPDATE_CONTACT_START`)
export const fakeUpdateContact = createAction(`${prefix}FAKE_UPDATE_CONTACT`)
export const revertFakeUpdateContact = createAction(`${prefix}REVERT_FAKE_UPDATE_CONTACT`)
export const updateContactSuccess = createAction(`${prefix}UPDATE_CONTACT_SUCCESS`)
export const updateContactError = createAction(`${prefix}UPDATE_CONTACT_ERROR`)

export const resetContactStart = createAction(`${prefix}RESET_CONTACT_START`)
export const resetContactSuccess = createAction(`${prefix}RESET_CONTACT_SUCCESS`)
export const resetContactError = createAction(`${prefix}RESET_CONTACT_ERROR`)

export const deleteContactsStart = createAction(`${prefix}DELETE_CONTACTS_START`)
export const deleteContactsSuccess = createAction(`${prefix}DELETE_CONTACTS_SUCCESS`)
export const deleteContactsError = createAction(`${prefix}DELETE_CONTACTS_ERROR`)

export const updateDistributionListFormData = createAction(`${prefix}UPDATE_DISTRIBUTION_LIST_FORM_DATA`)
export const updateContactRanking = createAction(`${prefix}UPDATE_CONTACT_RANKING`)

export const addContactsToDistributionListStart = createAction(`${prefix}ADD_CONTACTS_TO_DISTRIBUTION_LIST_START`)
export const addContactsToDistributionListSuccess = createAction(`${prefix}ADD_CONTACTS_TO_DISTRIBUTION_LIST_SUCCESS`)
export const addContactsToDistributionListError = createAction(`${prefix}ADD_CONTACTS_TO_DISTRIBUTION_LIST_ERROR`)

export const addContactToListStart = createAction(`${prefix}ADD_CONTACT_TO_LIST_START`)
export const addContactToListSuccess = createAction(`${prefix}ADD_CONTACT_TO_LIST_SUCCESS`)
export const addContactToListError = createAction(`${prefix}ADD_CONTACT_TO_LIST_ERROR`)

export const removeContactsFromListStart = createAction(`${prefix}REMOVE_CONTACT_FROM_LIST_START`)
export const removeContactsFromListSuccess = createAction(`${prefix}REMOVE_CONTACT_FROM_LIST_SUCCESS`)
export const removeContactsFromListError = createAction(`${prefix}REMOVE_CONTACT_FROM_LIST_ERROR`)

export const removeContactsFromDistributionListsStart = createAction(`${prefix}REMOVE_CONTACTS_FROM_DISTRIBUTION_LISTS_START`)
export const removeContactsFromDistributionListsSuccess = createAction(`${prefix}REMOVE_CONTACTS_FROM_DISTRIBUTION_LISTS_SUCCESS`)
export const removeContactsFromDistributionListsError = createAction(`${prefix}REMOVE_CONTACTS_FROM_DISTRIBUTION_LISTS_ERROR`)

export const selectDistributionList = createAction(`${prefix}SELECT_DISTRIBUTION_LIST`)
export const clearSelectedDistributionLists = createAction(`${prefix}CLEAR_SELECTED_DISTRIBUTION_LISTS`)

export const searchContactsStart = createAction(`${prefix}SEARCH_CONTACTS_START`)
export const searchContactsSuccess = createAction(`${prefix}SEARCH_CONTACTS_SUCCESS`)
export const searchContactsError = createAction(`${prefix}SEARCH_CONTACTS_ERROR`)

export const searchDistributionListStart = createAction(`${prefix}SEARCH_DISTRIBUTION_LIST_START`)
export const searchDistributionListSuccess = createAction(`${prefix}SEARCH_DISTRIBUTION_LIST_SUCCESS`)
export const searchDistributionListError = createAction(`${prefix}SEARCH_DISTRIBUTION_LIST_ERROR`)

export const selectContactToAdd = createAction(`${prefix}SELECT_CONTACT_TO_ADD`)
export const selectAllContactsToAdd = createAction(`${prefix}SELECT_ALL_CONTACTS_TO_ADD`)
export const clearContactsToAdd = createAction(`${prefix}CLEAR_CONTACTS_TO_ADD`)

export const selectDistributionListContact = createAction(`${prefix}SELECT_DISTRIBUTION_LIST_CONTACT`)
export const selectAllDistributionListContacts = createAction(`${prefix}SELECT_ALL_DISTRIBUTION_LIST_CONTACTS`)
export const setSelectedDistributionListContacts = createAction(`${prefix}SET_SELECTED_DISTRIBUTION_LIST_CONTACTS`)
export const clearDistributionListContacts = createAction(`${prefix}CLEAR_DISTRIBUTION_LIST_CONTACTS`)

export const importUploadFileStart = createAction(`${prefix}IMPORT_UPLOAD_FILE_START`)
export const importUploadFileSuccess = createAction(`${prefix}IMPORT_UPLOAD_FILE_SUCCESS`)
export const importUploadFileError = createAction(`${prefix}IMPORT_UPLOAD_FILE_ERROR`)

export const importSetupStart = createAction(`${prefix}IMPORT_SETUP_START`)
export const importSetupSuccess = createAction(`${prefix}IMPORT_SETUP_SUCCESS`)
export const importSetupError = createAction(`${prefix}IMPORT_SETUP_ERROR`)

export const importFinalizeStart = createAction(`${prefix}IMPORT_FINALIZE_START`)
export const importFinalizeSuccess = createAction(`${prefix}IMPORT_FINALIZE_SUCCESS`)
export const importFinalizeError = createAction(`${prefix}IMPORT_FINALIZE_ERROR`)
export const resetImportState = createAction(`${prefix}RESET_IMPORT_STATE`)

export const sendErrorReportStart = createAction(`${prefix}SEND_REPORT_ERROR_START`)
export const sendErrorReportSuccess = createAction(`${prefix}SEND_REPORT_ERROR_SUCCESS`)
export const sendErrorReportError = createAction(`${prefix}SEND_REPORT_ERROR_ERROR`)

export const updateImportFormData = createAction(`${prefix}UPDATE_IMPORT_FORM_DATA`)
export const setCsvDelimiter = createAction(`${prefix}SET_CSV_DELIMITER`)
export const setColumnMapping = createAction(`${prefix}SET_COLUMN_MAPPING`)
export const resetColumnMapping = createAction(`${prefix}RESET_COLUMN_MAPPING`)

export const downloadImportFailedContactsStart = createAction(`${prefix}DOWNLOAD_IMPORT_FAILED_CONTACTS_START`)
export const downloadImportFailedContactsSuccess = createAction(`${prefix}DOWNLOAD_IMPORT_FAILED_CONTACTS_SUCCESS`)
export const downloadImportFailedContactsError = createAction(`${prefix}DOWNLOAD_IMPORT_FAILED_CONTACTS_ERROR`)

export const exportContactsStart = createAction(`${prefix}EXPORT_CONTACTS_START`)
export const exportContactsSuccess = createAction(`${prefix}EXPORT_CONTACTS_SUCCESS`)
export const exportContactsError = createAction(`${prefix}EXPORT_CONTACTS_ERROR`)

export const uploadPictureStart = createAction(`${prefix}UPLOAD_PICTURE_START`)
export const uploadPictureSuccess = createAction(`${prefix}UPLOAD_PICTURE_SUCCESS`)
export const uploadPictureError = createAction(`${prefix}UPLOAD_PICTURE_ERROR`)

export const setSuggestedContactData = createAction(`${prefix}SET_SUGGESTED_CONTACT_DATA`)
export const setSelectedContactsToReplace = createAction(`${prefix}SET_SELECTED_CONTACTS_TO_REPLACE`)
export const replaceAllContacts = createAction(`${prefix}REPLACE_ALL_CONTACTS`)

export const importSuggestedContactStart = createAction(`${prefix}IMPORT_SUGGESTED_CONTACT_START`)
export const importSuggestedContactSuccess = createAction(`${prefix}IMPORT_SUGGESTED_CONTACT_SUCCESS`)
export const importSuggestedContactError = createAction(`${prefix}IMPORT_SUGGESTED_CONTACT_ERROR`)

export const replaceContactsStart = createAction(`${prefix}REPLACE_CONTACTS_START`)
export const replaceContactsSuccess = createAction(`${prefix}REPLACE_CONTACTS_SUCCESS`)
export const replaceContactsError = createAction(`${prefix}REPLACE_CONTACTS_ERROR`)

// UI
prefix = `${defaultPrefix}UI/`

export const setQuery = createAction(`${prefix}SET_QUERY`)

export const setSelectedMainTab = createAction(`${prefix}SET_SELECTED_MAIN_TAB`)
export const setSelectedListTab = createAction(`${prefix}SET_SELECTED_LIST_TAB`)
export const setSelectedContactTab = createAction(`${prefix}SET_SELECTED_CONTACT_TAB`)
export const setSelectedQueryType = createAction(`${prefix}SET_SELECTED_QUERY_TYPE`)
export const uiEnteredQuery = createAction(`${prefix}ENTERED_QUERY`)

export const setContactsDataGridSettings = createAction(`${prefix}SET_CONTACTS_DATA_GRID_SETTINGS`)
export const clearSelectedContacts = createAction(`${prefix}CLEAR_SELECTED_CONTACTS`)
export const setDistributionListsDataGridSettings = createAction(`${prefix}SET_DISTRIBUTION_LISTS_DATA_GRID_SETTINGS`)

export const setDetailPageContactId = createAction(`${prefix}SET_DETAIL_PAGE_CONTACT_ID`)

export const setContactsPage = createAction(`${prefix}SET_CONTACTS_PAGE`)
export const setContactDetailsEditMode = createAction(`${prefix}SET_CONTACT_DETAILS_EDIT_MODE`)

export const setNewContactData = createAction(`${prefix}SET_NEW_CONTACT_DATA`)
export const resetNewContactData = createAction(`${prefix}RESET_NEW_CONTACT_DATA`)

export const openDistributionListDetails = createAction(`${prefix}OPEN_DISTRIBUTION_LIST_DETAILS`)

export const openContactsDeleteDialog = createAction(`${prefix}OPEN_CONTACTS_DELETE_DIALOG`)
export const closeContactsDeleteDialog = createAction(`${prefix}CLOSE_CONTACTS_DELETE_DIALOG`)

export const openContactsExportDialog = createAction(`${prefix}OPEN_CONTACTS_EXPORT_DIALOG`)
export const closeContactsExportDialog = createAction(`${prefix}CLOSE_CONTACTS_EXPORT_DIALOG`)

export const openDistributionListCreateDialog = createAction(`${prefix}OPEN_DISTRIBUTION_LIST_CREATE_DIALOG`)
export const closeDistributionListCreateDialog = createAction(`${prefix}CLOSE_DISTRIBUTION_LIST_CREATE_DIALOG`)

export const openDistributionListDeleteDialog = createAction(`${prefix}OPEN_DISTRIBUTION_LIST_DELETE_DIALOG`)
export const closeDistributionListDeleteDialog = createAction(`${prefix}CLOSE_DISTRIBUTION_LIST_DELETE_DIALOG`)

export const openDistributionListUpdateDialog = createAction(`${prefix}OPEN_DISTRIBUTION_LIST_UPDATE_DIALOG`)
export const closeDistributionListUpdateDialog = createAction(`${prefix}CLOSE_DISTRIBUTION_LIST_UPDATE_DIALOG`)

export const openDistributionListMergeDialog = createAction(`${prefix}OPEN_DISTRIBUTION_LIST_MERGE_DIALOG`)
export const closeDistributionListMergeDialog = createAction(`${prefix}CLOSE_DISTRIBUTION_LIST_MERGE_DIALOG`)

export const openDistributionListExportUnavailableDialog = createAction(`${prefix}OPEN_DISTRIBUTION_LIST_EXPORT_UNAVAILABLE_DIALOG`)
export const closeDistributionListExportUnavailableDialog = createAction(`${prefix}CLOSE_DISTRIBUTION_LIST_EXPORT_UNAVAILABLE_DIALOG`)

export const openContactCreateDialog = createAction(`${prefix}OPEN_CONTACT_CREATE_DIALOG`)
export const closeContactCreateDialog = createAction(`${prefix}CLOSE_CONTACT_CREATE_DIALOG`)

export const openContactsAddDialog = createAction(`${prefix}OPEN_CONTACTS_ADD_DIALOG`)
export const closeContactsAddDialog = createAction(`${prefix}CLOSE_CONTACTS_ADD_DIALOG`)

export const openContactsRemoveFromListsDialog = createAction(`${prefix}OPEN_CONTACTS_REMOVE_FROM_LISTS_DIALOG`)
export const closeContactsRemoveFromListsDialog = createAction(`${prefix}CLOSE_CONTACTS_REMOVE_FROM_LISTS_DIALOG`)

export const openContactRemoveDialog = createAction(`${prefix}OPEN_CONTACT_REMOVE_DIALOG`)
export const closeContactRemoveDialog = createAction(`${prefix}CLOSE_CONTACT_REMOVE_DIALOG`)

export const openContactReportErrorDialog = createAction(`${prefix}OPEN_CONTACT_REPORT_ERROR_DIALOG`)
export const closeContactReportErrorDialog = createAction(`${prefix}CLOSE_CONTACT_REPORT_ERROR_DIALOG`)

export const openImportPage = createAction(`${prefix}OPEN_IMPORT_PAGE`)

export const closeDetailPages = createAction(`${prefix}CLOSE_DETAIL_PAGES`)
export const closeContactDetailsPage = createAction(`${prefix}CLOSE_CONTACT_DETAILS_PAGE`)

export const returnToDistributionList = createAction(`${prefix}RETURN_TO_DISTRIBUTION_LIST`)
export const returnToContact = createAction(`${prefix}RETURN_TO_CONTACT`)

export const openContactDetailsAddListDialog = createAction(`${prefix}OPEN_CONTACT_DETAILS_ADD_LIST_DIALOG`)
export const closeContactDetailsAddListDialog = createAction(`${prefix}CLOSE_CONTACT_DETAILS_ADD_LIST_DIALOG`)

export const openContactSuggestDialog = createAction(`${prefix}OPEN_CONTACT_SUGGEST_DIALOG`)
export const closeContactSuggestDialog = createAction(`${prefix}CLOSE_CONTACT_SUGGEST_DIALOG`)

export const switchToListContactDetails = createAction(`${prefix}SWITCH_TO_LIST_CONTACT_DETAILS`)
export const switchToContactListDetails = createAction(`${prefix}SWITCH_TO_CONTACT_LIST_DETAILS`)
export const switchToSearchPool = createAction(`${prefix}SWITCH_TO_SEARCH_POOL`)
